// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
  border: none;
  border-radius: 8px;
  filter: drop-shadow(8px 12px 30px rgba(0, 0, 147, 0.07));
}

.react-datepicker__triangle {
  display: none;
}

.react-datepicker__month-container {
  border-radius: 8px;
}

.react-datepicker__header {
  padding: 10px 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid #d8d8ff;
  background: #f5f5ff;
}
.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 8px;
}

button.react-datepicker__navigation {
  display: none;
}

.react-datepicker__navigation {
  top: 11px;
}
.react-datepicker__navigation--years {
  top: 0;
  height: 20px;
}
.react-datepicker__navigation--years-upcoming, .react-datepicker__navigation--years-previous {
  position: relative;
}
.react-datepicker__navigation--years-upcoming::after, .react-datepicker__navigation--years-previous::after {
  content: "";
  position: absolute;
  left: 30%;
  display: block;
  width: 9px;
  height: 9px;
  border-style: solid;
  border-width: 1.5px 1.5px 0 0;
  border-color: #000093;
}
.react-datepicker__navigation--years-upcoming::after {
  top: 30%;
  transform: scale(0.6) rotate(-45deg);
}
.react-datepicker__navigation--years-previous::after {
  top: 15%;
  transform: scale(0.6) rotate(135deg);
}
.react-datepicker__navigation-icon::before {
  width: 8px;
  height: 8px;
  border-width: 1.5px 1.5px 0 0;
  border-color: #000093;
}

.react-datepicker__year-option:last-child {
  height: 20px;
}

.react-datepicker__current-month {
  display: none;
}

.react-datepicker__header__dropdown {
  margin-bottom: 10px;
  text-transform: capitalize;
  color: #000093;
}

.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  border-color: #d8d8ff;
  background: #fff;
}

.react-datepicker__month-dropdown-container {
  margin-left: 0;
}

.react-datepicker__month-read-view,
.react-datepicker__year-read-view {
  visibility: visible !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
}

.react-datepicker__month-read-view--down-arrow,
.react-datepicker__year-read-view--down-arrow {
  transform: scale(0.8) translate(-2px, 10px) rotate(135deg);
  border-width: 2px 2px 0 0;
  border-color: #000093;
}

.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow {
  border-top-color: #000093;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-read-view:hover {
  background: #f5f5ff;
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-read-view--selected {
  display: none;
}
.react-datepicker__year-option--selected_year, .react-datepicker__year-option--selected_month,
.react-datepicker__month-option--selected_year,
.react-datepicker__month-option--selected_month,
.react-datepicker__month-read-view--selected_year,
.react-datepicker__month-read-view--selected_month {
  background: #f5f5ff;
}

.react-datepicker__day-names {
  height: 24px;
}
.react-datepicker__day-names .react-datepicker__day-name {
  width: 24px;
  margin: 0 1px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #000093;
}

.react-datepicker__month {
  margin: 0;
  padding: 10px 8px;
}
.react-datepicker__month .react-datepicker__week {
  gap: 1px;
  height: 24px;
}
.react-datepicker__month .react-datepicker__week:not(:last-child) {
  margin-bottom: 5px;
}

.react-datepicker__day {
  width: 24px;
  height: 100%;
  padding: 2px 5px;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: #000093;
}
.react-datepicker__day--selected {
  outline-color: transparent;
}
.react-datepicker__day--outside-month, .react-datepicker__day--disabled {
  color: #8686ff;
}
.react-datepicker__day--selected {
  background: #4343ff;
  color: #fff;
}
.react-datepicker__day--selected:hover {
  background: #4343ff;
}

.react-datepicker__day,
.react-datepicker__day-name,
.react-datepicker__time-name {
  width: 24px;
  margin: 2px 1px;
}

.react-datepicker__day--keyboard-selected:hover {
  background: #f0f0f0;
}

.react-datepicker__input-time-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2px 0;
  padding: 6px 8px;
  border-top: 1px solid #d8d8ff;
}

.react-datepicker-time__caption {
  margin-right: 28px;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  color: #000093;
}
.react-datepicker-time__input input[type=time]::-webkit-calendar-picker-indicator {
  background: none;
  display: none;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  margin-left: 0;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: 115px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #00007a;
  border-radius: 8px;
  outline: none;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: #000093;
}

.react-datepicker__input-container input {
  width: 100%;
  height: 40px;
  padding: 6px 12px;
  border: 1px solid #00007a;
  border-radius: 8px;
  outline: none;
  color: #000093;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.react-datepicker__input-container input.datepicker-error {
  border: 1px solid #bd454a;
}
.react-datepicker__input-container input::placeholder {
  color: #d8d8ff;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.react-datepicker__input-container input.colabel {
  border: 1px solid #C3C3C9;
  color: #121217;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Datepicker/Datepicker.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,kBAAA;EACA,wDAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBCtBS;AD0BX;AAFE;EACE,4BAAA;AAIJ;;AAAA;EACE,aAAA;AAGF;;AAAA;EACE,SAAA;AAGF;AADE;EACE,MAAA;EACA,YAAA;AAGJ;AAAE;EAEE,kBAAA;AACJ;AACI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBChDK;ADiDX;AAII;EACE,QAAA;EACA,oCAAA;AAFN;AAOI;EACE,QAAA;EACA,oCAAA;AALN;AASE;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,qBCtEO;AD+DX;;AAYE;EACE,YAAA;AATJ;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,mBAAA;EACA,0BAAA;EACA,cCvFS;AD6EX;;AAaA;;EAEE,qBCjGS;EDkGT,gBAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;;EAEE,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVF;;AAaA;;EAEE,0DAAA;EACA,yBAAA;EACA,qBChHS;ADsGX;;AAaA;;EAEE,yBCrHS;AD2GX;;AAgBE;;;EACE,mBClIO;ADuHX;AAcE;;;EACE,aAAA;AAVJ;AAaE;;;;;EAEE,mBC3IO;ADmIX;;AAYA;EACE,YAAA;AATF;AAWE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClJO;ADyIX;;AAaA;EACE,SAAA;EACA,iBAAA;AAVF;AAYE;EACE,QAAA;EACA,YAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;;AAeA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3KS;AD+JX;AAcE;EACE,0BAAA;AAZJ;AAeE;EAEE,cCvLO;ADyKX;AAiBE;EACE,mBC1LO;ED2LP,WAAA;AAfJ;AAiBI;EACE,mBC9LK;AD+KX;;AAoBA;;;EAGE,WAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAjBF;;AAqBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC1NO;ADwMX;AAsBI;EACE,gBAAA;EACA,aAAA;AApBN;;AAyBA;EACE,cAAA;AAtBF;AAwBE;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClPO;AD4NX;;AA2BE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cC9PO;ED+PP,gBAAA;EACA,eAAA;EACA,iBAAA;AAxBJ;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,cC7QK;ED8QL,gBAAA;EACA,eAAA;EACA,iBAAA;AAzBN;AA4BI;EACE,yBAAA;EACA,cCjPe;ADuNrB","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.react-datepicker {\n  border: none;\n  border-radius: 8px;\n  filter: drop-shadow(8px 12px 30px rgba(0, 0, 147, 0.07));\n}\n\n.react-datepicker__triangle {\n  display: none;\n}\n\n.react-datepicker__month-container {\n  border-radius: 8px;\n}\n\n.react-datepicker__header {\n  padding: 10px 8px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  border-bottom: 1px solid colors.$primary2;\n  background: colors.$primary1;\n\n  &:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 8px;\n  }\n}\n\nbutton.react-datepicker__navigation {\n  display: none;\n}\n\n.react-datepicker__navigation {\n  top: 11px;\n\n  &--years {\n    top: 0;\n    height: 20px;\n  }\n\n  &--years-upcoming,\n  &--years-previous {\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 30%;\n      display: block;\n      width: 9px;\n      height: 9px;\n      border-style: solid;\n      border-width: 1.5px 1.5px 0 0;\n      border-color: colors.$primary7;\n    }\n  }\n\n  &--years-upcoming {\n    &::after {\n      top: 30%;\n      transform: scale(0.6) rotate(-45deg);\n    }\n  }\n\n  &--years-previous {\n    &::after {\n      top: 15%;\n      transform: scale(0.6) rotate(135deg);\n    }\n  }\n\n  &-icon::before {\n    width: 8px;\n    height: 8px;\n    border-width: 1.5px 1.5px 0 0;\n    border-color: colors.$primary7;\n  }\n}\n\n.react-datepicker__year-option {\n  &:last-child {\n    height: 20px;\n  }\n}\n\n.react-datepicker__current-month {\n  display: none;\n}\n\n.react-datepicker__header__dropdown {\n  margin-bottom: 10px;\n  text-transform: capitalize;\n  color: colors.$primary7;\n}\n\n.react-datepicker__month-dropdown,\n.react-datepicker__year-dropdown {\n  border-color: colors.$primary2;\n  background: #fff;\n}\n\n.react-datepicker__month-dropdown-container {\n  margin-left: 0;\n}\n\n.react-datepicker__month-read-view,\n.react-datepicker__year-read-view {\n  visibility: visible !important;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n}\n\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__year-read-view--down-arrow {\n  transform: scale(0.8) translate(-2px, 10px) rotate(135deg);\n  border-width: 2px 2px 0 0;\n  border-color: colors.$primary7;\n}\n\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow {\n  border-top-color: colors.$primary7;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-read-view {\n  &:hover {\n    background: colors.$primary1;\n  }\n\n  &--selected {\n    display: none;\n  }\n\n  &--selected_year,\n  &--selected_month {\n    background: colors.$primary1;\n  }\n}\n\n.react-datepicker__day-names {\n  height: 24px;\n\n  .react-datepicker__day-name {\n    width: 24px;\n    margin: 0 1px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: colors.$primary7;\n  }\n}\n\n.react-datepicker__month {\n  margin: 0;\n  padding: 10px 8px;\n\n  .react-datepicker__week {\n    gap: 1px;\n    height: 24px;\n\n    &:not(:last-child) {\n      margin-bottom: 5px;\n    }\n  }\n}\n\n.react-datepicker__day {\n  width: 24px;\n  height: 100%;\n  padding: 2px 5px;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 20px;\n  color: colors.$primary7;\n\n  &--selected {\n    outline-color: transparent;\n  }\n\n  &--outside-month,\n  &--disabled {\n    color: colors.$primary3;\n  }\n\n  &--selected {\n    background: colors.$primary4;\n    color: #fff;\n\n    &:hover {\n      background: colors.$primary4;\n    }\n  }\n}\n\n.react-datepicker__day,\n.react-datepicker__day-name,\n.react-datepicker__time-name {\n  width: 24px;\n  margin: 2px 1px;\n}\n\n.react-datepicker__day--keyboard-selected:hover {\n  background: #f0f0f0;\n}\n\n.react-datepicker__input-time-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 2px 0;\n  padding: 6px 8px;\n  border-top: 1px solid colors.$primary2;\n}\n\n.react-datepicker-time {\n  &__caption {\n    margin-right: 28px;\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 24px;\n    color: colors.$primary7;\n  }\n\n  &__input {\n    input[type='time']::-webkit-calendar-picker-indicator {\n      background: none;\n      display: none;\n    }\n  }\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  margin-left: 0;\n\n  input {\n    width: 115px;\n    height: 28px;\n    padding: 0 8px;\n    border: 1px solid colors.$primary8;\n    border-radius: 8px;\n    outline: none;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 20px;\n    color: colors.$primary7;\n  }\n}\n\n.react-datepicker__input-container {\n  input {\n    width: 100%;\n    height: 40px;\n    padding: 6px 12px;\n    border: 1px solid colors.$primary8;\n    border-radius: 8px;\n    outline: none;\n    color: colors.$primary7;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n\n    &.datepicker-error {\n      border: 1px solid colors.$danger5;\n    }\n\n    &::placeholder {\n      color: colors.$primary2;\n      font-weight: 300;\n      font-size: 16px;\n      line-height: 28px;\n    }\n\n    &.colabel{\n      border: 1px solid colors.$colabelNeutralMid;\n      color: colors.$colabelNeutralDark;\n    }\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`
};
export default ___CSS_LOADER_EXPORT___;
